import './Footer.css'

const Footer = () => {
  const currentYear = new Date().getFullYear()

  return (
    <footer className='footer'>
      <p className='footer__brand'>3M CODE SOLUTION</p>
      <p className='footer__copy'>All rights reserved, {currentYear}</p>
    </footer>
  )
}

export default Footer
